export const SS_KEY_DASHBOARD_FLASH_MESSAGE = 'dashboard.flash.message';
